module.exports = __webpack_public_path__ + "static/media/str-chat__connection-error.b3aba88d.svg";